<div style="max-width: 750px; margin-inline: auto;">
  <h2>{{"ONDEMAND.TITLE" | translate}}</h2>
  <div class="tabs-container">
    <div class="tab" [class.active]="activeTab === 'live_video'" (click)="selecTab('live_video')">{{"ONDEMAND.TAB1" | translate}}</div>
    <div class="tab" [class.active]="activeTab === 'time_challenge'" (click)="selecTab('time_challenge')">{{"ONDEMAND.TAB2" | translate}}</div>
  </div>
</div>
<div style="height: calc(100% - 205px); max-width: 750px; margin-inline: auto;">
  <div class="live-video-container" *ngIf="activeTab === 'live_video'">
    <div class="category-container" *ngIf="categories.length < 1">
      <swiper-container [slidesPerView]="2.5">
        <swiper-slide *ngFor="let item of categoriesPlaceholder">
          <div class="slide">
            <div class="category-chip">
              <div class="skeleton" style="height: 10px; width: 80px; margin-inline: auto;"></div>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
    <div class="category-container" *ngIf="categories.length > 0">
      <swiper-container [slidesPerView]="2.5">
        <swiper-slide *ngFor="let item of categories">
          <div class="slide">
            <div class="category-chip" (click)="openCategory(item)" [class.selected]="item.id === selectedCategory">
              <p>{{capitalizeFirstLetter(item.i18nName[translate.currentLang.toUpperCase()])}}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
  <vex-on-demand-category *ngIf="selectedCategory && activeTab === 'live_video'"></vex-on-demand-category>
  <vex-time-challenge-user *ngIf="activeTab === 'time_challenge'"></vex-time-challenge-user>
</div>
